<template>
	<div class="home">
		<div class="data_box">
			<div class="list animate__animated animate__fadeInUp" >
				<ul>
					<li>
						<div class="pic">
							<img src="../../../public/images/channel-1.png" >
						</div>
						<div class="right">
							<div class="tit">服务品牌 </div>
							<div class="num">
								<countTo class="count" :startVal='startVal' :endVal='Number(brand)' :duration='duration'></countTo>
								+
								<!-- <span>个</span> -->
							</div>
						</div>
					</li>
					
					<li>
						<div class="pic">
							<img src="../../../public/images/channel-2.png" >
						</div>
						<div class="right">
							<div class="tit">服务门店</div>
							<div class="num">
								<countTo class="count" :startVal='startVal' :endVal='Number(store)' :duration='duration'></countTo>
								+
								<!-- <span>个</span> -->
							</div>
						</div>
					</li>
					
					<li>
						<div class="pic">
							<img src="../../../public/images/bj13.png" >
						</div>
						<div class="right">
							<div class="tit">链接消费者</div>
							<div class="num">
								<countTo class="count" :startVal='startVal' :endVal='Number(consumer)' :duration='duration'></countTo>
								+
								<!-- <span>个</span> -->
							</div>
						</div>
					</li>
					
					<li>
						<div class="pic">
							<img src="../../../public/images/channel-3.png" >
						</div>
						<div class="right">
							<div class="tit">覆盖全国城市</div>
							<div class="num">
								<countTo class="count" :startVal='startVal' :endVal='Number(city)' :duration='duration'></countTo>
								+
								<!-- <span>个</span> -->
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="text animate__animated animate__fadeInUp" ref='partCooperation'>
				部分已合作案例展示
				<span>查看更多案例请联系我们</span>
			</div>
		</div>
		<div class="case">
			<ul ref="store">
				<li  v-show="storeShow" class="animate__animated animate__fadeInUp" v-for="(item,index) in caseList" :key='index' >
					<div class="left">
						<div class="pic">
							<img :src="imageHttp(item.image)" >
						</div>
						<div class="text">
							{{item.name}}
							<span>
								{{item.shop_memo}}
							</span>
						</div>
					</div>
					<div class="right">
						<div class="wrap">
							<div class="box">
								<div class="tit">线上曝光次数：</div>
								<div class="num">{{item.exposure}}</div>
							</div>
							<div class="box">
								<div class="tit">门店获客人数：</div>
								<div class="num">{{item.customers}}</div>
							</div>
							<div class="box">
								<div class="tit">预计到店人数：</div>
								<div class="num">{{item.to_store}}</div>
							</div>
							<div class="box">
								<div class="tit">活动转化金额：</div>
								<div class="num">{{item.conversion_price}}</div>
							</div>
						</div>
						<div class="btm">{{item.conversion_memo}}</div>
					</div>
				</li>
			</ul>
			
			<div ref="case">
				<div v-show="caseShow" class="more animate__animated animate__fadeInUp">
					咨询更多行业案例
				</div>
			</div>
		</div>
		<div style="height: 50px;"></div>
		<!-- 商家展示 -->
		<brand-box></brand-box>
		<!-- 底部信息 -->
		<my-footer></my-footer>
	</div>
</template>

<script>
import countTo from 'vue-count-to';
import { getScroll } from '@/static/js/utils.js'
import myFooter from '@/components/myFooter/index.vue'
import brandBox from '@/components/brandBox/index.vue'
import { indexExample ,indexRecord } from '@/api'
import { imageHttp } from '@/static/js/utils.js'
export default {
	components:{
		myFooter,
		brandBox,
		countTo 
	},
	data() {
		return{
			close: true,
			storeShow: true,
			caseShow: true,
			contactShow: true,
			duration:5000,
			startVal:0,
			brand:'',
			store:'',
			consumer:'',
			city:'', 
			caseList:[],												//案例展示
		}
	},
	created() {
		this.getIndexExample()
		this.getIndexRecord()
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
		window.addEventListener("scroll", this.handle);
	},
	methods:{
		imageHttp,
		// 获取数据展示
		getIndexRecord(){
			indexRecord().then(res => {
				if(res.code == 200){
					this.brand = res.data.info.brand 		//服务品牌
					this.store = res.data.info.store 		//服务门店
					this.consumer = res.data.info.consumer  //链接消费者
					this.city = res.data.info.city		//覆盖全国城市
				}else{
					console.log(res.msg)
				}
			})
		},
		// 获取案例展示
		getIndexExample(){
			indexExample().then(res => {
				if(res.code == 200){
					this.caseList = res.data.list
				}else{
					console.log(res.msg)
				}
				// console.log(res)
			})
		},
		handleScroll () { // 实现当滚动到指定位置，触发动画
			// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
			// this.gdjz('earth', 'earth animated bounceInDown', 50)
			let _this = this
			let refArray = [
				{ref: 'store', show: 'storeShow'},
				{ref: 'case', show: 'caseShow'},
				{ref: 'contact', show: 'contactShow'},
		      ]
			  // console.log(refArray)
			refArray.forEach((r,i) => {
				_this.gdjz(r.ref, 20, () => {
					_this[r.show] = true
				})
			})
		},
		gdjz(div, offset, callback) {
			let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
			// console.log(dom)
			if(dom){
				var a,b,c,d;
				d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
				a = eval(d + offset)
				b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
				c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
				if( b + c > a ) {
					callback && callback()
				}
			}
		},
		handle () { // 实现当滚动到指定位置，触发动画
			// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
			// this.gdjz('earth', 'earth animated bounceInDown', 50)
			let _this = this
			let refArray = [
				{ref: 'store', show: 'storeShow'},
				{ref: 'case', show: 'caseShow'},
				{ref: 'shop', show: 'shopShow'},
				{ref: 'oem', show: 'oemShow'},
				{ref: 'contact', show: 'contactShow'},
				{ref: 'footer', show: 'footerShow'},
				// {ref: 'dixian', show: 'dixianShow'}
		      ]
			  // console.log(refArray)
			refArray.forEach((r,i) => {
				_this.gd(r.ref, 20, () => {
					_this[r.show] = false
				})
			})
		},
		gd(div, offset, callback) {
			let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
			// console.log(dom)
			if(dom){
				var a,b,c,d;
				d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
				a = eval(d + offset)
				b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
				c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
				if( b + c < a ) {
					callback && callback()
				}
			}
		},
	}
}
</script>
 
<style lang="scss" scoped>
	.home{
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		
		.data_box{
			width: 100%;
			height: 2.75rem;
			background-color: #fff;
			display: flex;
			flex-direction: column;
			align-items: center;
			
			.list{
				width:62.5% ;
				height: 1.5rem;
				background: #FFFDFB;
				box-shadow: 0rem 0.13rem 0.24rem 0rem rgba(244, 244, 244, 0.82);
				border-radius: 0.3rem;
				margin-top: -0.53rem;
				z-index: 1;
				display: flex;
				
				
				ul{
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-around;
					li{
						// width: 16%;
						height: 0.71rem;
						display: flex;
						justify-content: space-between;
						.pic{
							width: 0.64rem;
							height: 0.61rem;
							margin-top: 0.1rem;
							display: flex;
							img{
								width: 0.64rem;
								height: 0.61rem;
							}
						}
						.right{
							margin-left: 0.17rem;
							.tit{
								font-size: 0.14rem;
								color: #565656;
								margin-bottom: 0.2rem;
							}
							.num{
								font-size: 0.38rem;
								color: #FF7300;
								.count{
									font-size: 0.38rem;
									color: #FF7300;
								}
								span{
									font-size: 0.14rem;
									color: #565656;
								}
							}
						}
					}
				}
			}
			.text{
				font-size: 0.28rem;
				color: #000000;
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-top: 0.67rem;
				
				span{
					font-size: 0.18rem;
					color: #999999;
					margin-top: 0.18rem;
				}
			}
		}
		.case{
			width:62.5% ;
			min-height: 2.7rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			
			ul{
				width: 100%;
				min-height: 2.7rem;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				li{
					width: 47.5%;
					height: 2.7rem;
					background: #FFFFFF;
					box-shadow: 0rem 0.13rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
					border-radius: 0.4rem;
					display: flex;
					align-items: center;
					margin-top: 0.52rem;
					
					.left{
						width: 32%;
						height: 2rem;
						border-right: 0.01rem solid #D3D3D3;
						// margin-top: 0.32rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						
						.pic{
							width: 1.2rem;
							height:1.2rem;
							border-radius: 50%;
							img{
								width: 1.2rem;
								height:1.2rem;
								border-radius: 50%;
							}
						}
						.text{
							font-size: 0.24rem;
							color: #333333;
							display: flex;
							flex-direction: column;
							align-items: center;
							margin-top: 0.22rem;
							span{
								font-size: 0.16rem;
								color: #999999;
								margin-top: 0.11rem;
							}
						}
					}
					.right{
						width: 67%;
						height: 2rem;
						.wrap{
							width: 2.85rem;
							// height: 1.26rem;
							display: flex;
							flex-wrap:wrap;
							justify-content: space-between;
							margin-top: 0.16rem;
							margin-left: 0.34rem;
							.box{
								display: flex;
								flex-direction: column;
								margin-bottom: 0.26rem;
								
								.tit{
									// width: 1.2rem;
									height: 0.16rem;
									font-size: 0.16rem;
									color: #939394;
									margin-bottom: 0.14rem;
								}
								.num{
									width: 0.75rem;
									height: 0.2rem;
									font-size: 0.28rem;
									color: #FF7402;
								}
							}
						}
						.btm{
							height: 0.19rem;
							font-size: 0.2rem;
							color: #333333;
							margin-left: 0.34rem;
						}
					}
				}
			}
			.more{
				width: 2.71rem;
				height: 0.58rem;
				background: linear-gradient(181deg, #FE9315, #FEA315);
				box-shadow: 0rem 0.06rem 0.08rem 0rem rgba(0, 0, 0, 0.04);
				border-radius: 0.14rem;
				font-size: 0.24rem;
				text-align: center;
				line-height: 0.58rem;
				color: #FFFFFF;
				margin-top: 0.72rem;
			}
		}
		
	}
	// 移动端样式
	@media (max-width:1206px){
		.home{
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			
			.data_box{
				width: 100%;
				height: 4.08rem;
				background-color: #fff;
				
				.list{
					width: 6.9rem;
					height: 2.5rem;
					margin-top: 0;
					margin-bottom: 0.59rem;
					
					ul{
						width: 6.9rem;
						height: 2.5rem;
						display: flex;
						justify-content: space-between;
						flex-flow: wrap;
						
						li{
							width: 3.4rem;
							height: 1.2rem;
							background: #FFFDFB;
							box-shadow: 0px 0.13rem 0.24rem 0px rgba(244, 244, 244, 0.82);
							border-radius: 0.3rem;
							display: flex;
							justify-content: center;
							
							.pic{
								width: 0.64rem;
								height: 0.61rem;
								margin-top: 0.35rem;
								margin-right: 0.21rem;
							}
							.right{
								width: 2rem;
								margin-top: 0.25rem;
								font-size: 0.14rem;
								color: #565656;
								
								.num{
									font-size: 0.28rem;
									color: #FF7300;
									span{
										font-size: 0.14rem;
										color: #565656;
									}
								}
							}
						}
					}
				}
				.text{
					margin-top: 0;
					font-size: 0.32rem;
					.span{
						font-size: 0.24rem;
					}
				}
			}
			.case{
				width: 100%;
				min-block-size: 3.26rem;
				ul{
					width: 6.9rem;
					min-height: 3.26rem;
					background: #FFFFFF;
					margin-top: 0.38rem;
					background-color: transparent;
					li{
						width: 6.9rem;
						min-height: 3.26rem;
						background: #FFFFFF;
						background-color: #fff;
						box-shadow: 0px 0.13rem 0.24rem 0px rgba(51, 51, 51, 0.05);
						border-radius: 0.2rem;
						.left{
							width: 2.22rem;
							height: 2.41rem;
							.pic{
								width: 1.45rem;
								height: 1.45rem;
								border-radius: 50%;
								img{
									width: 1.45rem;
									height: 1.45rem;
									border-radius: 50%;
								}
							}
							.text{
								font-size: 0.28rem;
								margin-top: 0.27rem;
								span{
									font-size: 0.2rem;
								}
							}
						}
						.right{
							width: 4.67rem;
							height: 2.41rem;
							.wrap{
								width: 4rem;
								// height: 1.26rem;
								display: flex;
								flex-wrap:wrap;
								justify-content: space-between;
								margin-top: 0.16rem;
								margin-left: 0.41rem;
								.box{
									display: flex;
									flex-direction: column;
									margin-bottom: 0.26rem;
									
									.tit{
										// width: 1.2rem;
										height: 0.2rem;
										font-size: 0.2rem;
										color: #939394;
										margin-bottom: 0.14rem;
									}
									.num{
										// width: 0.75rem;
										height: 0.32rem;
										font-size: 0.22rem;
										color: #FF7402;
									}
								}
							}
							.btm{
								height: 0.19rem;
								font-size: 0.24rem;
								color: #333333;
								margin-left: 0.41rem;
							}
						}
					}
				}
				.more{
					width: 2.71rem;
					height: 0.58rem;
					background: linear-gradient(181deg, #FE9315, #FEA315);
					box-shadow: 0px 0.06rem 0.08rem 0px rgba(0, 0, 0, 0.04);
					border-radius: 0.14rem;
					font-size: 0.24rem;
					margin-top: 0.51rem;
				}
			}
		}
	}
	
</style>